import type { AlertDefinition } from '@/types/alerts/alert.model'
import i18n from '@/i18n'

const { t } = i18n.global

export const ALERT_DEFINITIONS: AlertDefinition = {
  '03a173b5-c153-40ff-a330-70330d3f2746': {
    description: t('alerts.definitions.03a173b5-c153-40ff-a330-70330d3f2746.description'),
    potential: {
      causes: t('alerts.definitions.03a173b5-c153-40ff-a330-70330d3f2746.potential.causes'),
      impact: t('alerts.definitions.03a173b5-c153-40ff-a330-70330d3f2746.potential.impact'),
      solutions: t('alerts.definitions.03a173b5-c153-40ff-a330-70330d3f2746.potential.solutions'),
    },
    title: t('alerts.definitions.03a173b5-c153-40ff-a330-70330d3f2746.title'),
  },
  '0918bde1-511f-4454-a45d-c433baaad71e': {
    description: t('alerts.definitions.0918bde1-511f-4454-a45d-c433baaad71e.description'),
    potential: {
      causes: t('alerts.definitions.0918bde1-511f-4454-a45d-c433baaad71e.potential.causes'),
      impact: t('alerts.definitions.0918bde1-511f-4454-a45d-c433baaad71e.potential.impact'),
      solutions: t('alerts.definitions.0918bde1-511f-4454-a45d-c433baaad71e.potential.solutions'),
    },
    title: t('alerts.definitions.0918bde1-511f-4454-a45d-c433baaad71e.title'),
  },
  '0ad21787-4ab4-4d3c-9e7d-6b9d2e5fdac2': {
    description: t('alerts.definitions.0ad21787-4ab4-4d3c-9e7d-6b9d2e5fdac2.description'),
    potential: {
      causes: t('alerts.definitions.0ad21787-4ab4-4d3c-9e7d-6b9d2e5fdac2.potential.causes'),
      impact: t('alerts.definitions.0ad21787-4ab4-4d3c-9e7d-6b9d2e5fdac2.potential.impact'),
      solutions: t('alerts.definitions.0ad21787-4ab4-4d3c-9e7d-6b9d2e5fdac2.potential.solutions'),
    },
    title: t('alerts.definitions.0ad21787-4ab4-4d3c-9e7d-6b9d2e5fdac2.title'),
  },
  '0d545599-8aff-492a-b91e-573cce42e9e8': {
    description: t('alerts.definitions.0d545599-8aff-492a-b91e-573cce42e9e8.description'),
    potential: {
      causes: t('alerts.definitions.0d545599-8aff-492a-b91e-573cce42e9e8.potential.causes'),
      impact: t('alerts.definitions.0d545599-8aff-492a-b91e-573cce42e9e8.potential.impact'),
      solutions: t('alerts.definitions.0d545599-8aff-492a-b91e-573cce42e9e8.potential.solutions'),
    },
    title: t('alerts.definitions.0d545599-8aff-492a-b91e-573cce42e9e8.title'),
  },
  '10d48ab3-122b-440c-85ed-a9b082024608': {
    description: t('alerts.definitions.10d48ab3-122b-440c-85ed-a9b082024608.description'),
    potential: {
      causes: t('alerts.definitions.10d48ab3-122b-440c-85ed-a9b082024608.potential.causes'),
      impact: t('alerts.definitions.10d48ab3-122b-440c-85ed-a9b082024608.potential.impact'),
      solutions: t('alerts.definitions.10d48ab3-122b-440c-85ed-a9b082024608.potential.solutions'),
    },
    title: t('alerts.definitions.10d48ab3-122b-440c-85ed-a9b082024608.title'),
  },
  '1903371d-5d33-4d02-a224-1813c7af1313': {
    description: t('alerts.definitions.1903371d-5d33-4d02-a224-1813c7af1313.description'),
    potential: {
      causes: t('alerts.definitions.1903371d-5d33-4d02-a224-1813c7af1313.potential.causes'),
      impact: t('alerts.definitions.1903371d-5d33-4d02-a224-1813c7af1313.potential.impact'),
      solutions: t('alerts.definitions.1903371d-5d33-4d02-a224-1813c7af1313.potential.solutions'),
    },
    title: t('alerts.definitions.1903371d-5d33-4d02-a224-1813c7af1313.title'),
  },
  '1db8c12a-b85a-47f4-9d3e-628c8ee8ebef': {
    description: t('alerts.definitions.1db8c12a-b85a-47f4-9d3e-628c8ee8ebef.description'),
    potential: {
      causes: t('alerts.definitions.1db8c12a-b85a-47f4-9d3e-628c8ee8ebef.potential.causes'),
      impact: t('alerts.definitions.1db8c12a-b85a-47f4-9d3e-628c8ee8ebef.potential.impact'),
      solutions: t('alerts.definitions.1db8c12a-b85a-47f4-9d3e-628c8ee8ebef.potential.solutions'),
    },
    title: t('alerts.definitions.1db8c12a-b85a-47f4-9d3e-628c8ee8ebef.title'),
  },
  '2a6c7a1a-d052-4305-883a-95aa8e3c47d7': {
    description: t('alerts.definitions.2a6c7a1a-d052-4305-883a-95aa8e3c47d7.description'),
    potential: {
      causes: t('alerts.definitions.2a6c7a1a-d052-4305-883a-95aa8e3c47d7.potential.causes'),
      impact: t('alerts.definitions.2a6c7a1a-d052-4305-883a-95aa8e3c47d7.potential.impact'),
      solutions: t('alerts.definitions.2a6c7a1a-d052-4305-883a-95aa8e3c47d7.potential.solutions'),
    },
    title: t('alerts.definitions.2a6c7a1a-d052-4305-883a-95aa8e3c47d7.title'),
  },
  '238446ff-f07a-41de-a052-5834dd044d0e': {
    description: t('alerts.definitions.238446ff-f07a-41de-a052-5834dd044d0e.description'),
    potential: {
      causes: t('alerts.definitions.238446ff-f07a-41de-a052-5834dd044d0e.potential.causes'),
      impact: t('alerts.definitions.238446ff-f07a-41de-a052-5834dd044d0e.potential.impact'),
      solutions: t('alerts.definitions.238446ff-f07a-41de-a052-5834dd044d0e.potential.solutions'),
    },
    title: t('alerts.definitions.238446ff-f07a-41de-a052-5834dd044d0e.title'),
  },
  '26c94a85-c9a7-4f68-85cc-ce9c168d2a59': {
    description: t('alerts.definitions.26c94a85-c9a7-4f68-85cc-ce9c168d2a59.description'),
    potential: {
      causes: t('alerts.definitions.26c94a85-c9a7-4f68-85cc-ce9c168d2a59.potential.causes'),
      impact: t('alerts.definitions.26c94a85-c9a7-4f68-85cc-ce9c168d2a59.potential.impact'),
      solutions: t('alerts.definitions.26c94a85-c9a7-4f68-85cc-ce9c168d2a59.potential.solutions'),
    },
    title: t('alerts.definitions.26c94a85-c9a7-4f68-85cc-ce9c168d2a59.title'),
  },
  '2db8c12a-b85a-47f4-9d3e-628c8ee8ebef': {
    description: t('alerts.definitions.2db8c12a-b85a-47f4-9d3e-628c8ee8ebef.description'),
    potential: {
      causes: t('alerts.definitions.2db8c12a-b85a-47f4-9d3e-628c8ee8ebef.potential.causes'),
      impact: t('alerts.definitions.2db8c12a-b85a-47f4-9d3e-628c8ee8ebef.potential.impact'),
      solutions: t('alerts.definitions.2db8c12a-b85a-47f4-9d3e-628c8ee8ebef.potential.solutions'),
    },
    title: t('alerts.definitions.2db8c12a-b85a-47f4-9d3e-628c8ee8ebef.title'),
  },
  '30759199-bcef-42c3-9a53-a898e2c29227': {
    description: t('alerts.definitions.30759199-bcef-42c3-9a53-a898e2c29227.description'),
    potential: {
      causes: t('alerts.definitions.30759199-bcef-42c3-9a53-a898e2c29227.potential.causes'),
      impact: t('alerts.definitions.30759199-bcef-42c3-9a53-a898e2c29227.potential.impact'),
      solutions: t('alerts.definitions.30759199-bcef-42c3-9a53-a898e2c29227.potential.solutions'),
    },
    title: t('alerts.definitions.30759199-bcef-42c3-9a53-a898e2c29227.title'),
  },
  '3182e5b1-f09b-4313-9c02-48cff9804970': {
    description: t('alerts.definitions.3182e5b1-f09b-4313-9c02-48cff9804970.description'),
    potential: {
      causes: t('alerts.definitions.3182e5b1-f09b-4313-9c02-48cff9804970.potential.causes'),
      impact: t('alerts.definitions.3182e5b1-f09b-4313-9c02-48cff9804970.potential.impact'),
      solutions: t('alerts.definitions.3182e5b1-f09b-4313-9c02-48cff9804970.potential.solutions'),
    },
    title: t('alerts.definitions.3182e5b1-f09b-4313-9c02-48cff9804970.title'),
  },
  '37a38178-57cc-400e-b99f-240a6978083d': {
    description: t('alerts.definitions.37a38178-57cc-400e-b99f-240a6978083d.description'),
    potential: {
      causes: t('alerts.definitions.37a38178-57cc-400e-b99f-240a6978083d.potential.causes'),
      impact: t('alerts.definitions.37a38178-57cc-400e-b99f-240a6978083d.potential.impact'),
      solutions: t('alerts.definitions.37a38178-57cc-400e-b99f-240a6978083d.potential.solutions'),
    },
    title: t('alerts.definitions.37a38178-57cc-400e-b99f-240a6978083d.title'),
  },
  '42bc7b46-921b-4619-b730-fc2a77fe7ed3': {
    description: t('alerts.definitions.42bc7b46-921b-4619-b730-fc2a77fe7ed3.description'),
    potential: {
      causes: '',
      impact: '',
      solutions: '',
    },
    title: t('alerts.definitions.42bc7b46-921b-4619-b730-fc2a77fe7ed3.title'),
  },
  '49d54ccd-5b02-4984-9cb2-06a48d5956a8': {
    description: t('alerts.definitions.49d54ccd-5b02-4984-9cb2-06a48d5956a8.description'),
    potential: {
      causes: t('alerts.definitions.49d54ccd-5b02-4984-9cb2-06a48d5956a8.potential.causes'),
      impact: t('alerts.definitions.49d54ccd-5b02-4984-9cb2-06a48d5956a8.potential.impact'),
      solutions: t('alerts.definitions.49d54ccd-5b02-4984-9cb2-06a48d5956a8.potential.solutions'),
    },
    title: t('alerts.definitions.49d54ccd-5b02-4984-9cb2-06a48d5956a8.title'),
  },
  '4bed18d6-93b8-41d6-b7d8-24044e8f4ea8': {
    description: t('alerts.definitions.4bed18d6-93b8-41d6-b7d8-24044e8f4ea8.description'),
    potential: {
      causes: t('alerts.definitions.4bed18d6-93b8-41d6-b7d8-24044e8f4ea8.potential.causes'),
      impact: t('alerts.definitions.4bed18d6-93b8-41d6-b7d8-24044e8f4ea8.potential.impact'),
      solutions: t('alerts.definitions.4bed18d6-93b8-41d6-b7d8-24044e8f4ea8.potential.solutions'),
    },
    title: t('alerts.definitions.4bed18d6-93b8-41d6-b7d8-24044e8f4ea8.title'),
  },
  '4c3d940f-da5f-415f-b766-6e75cdc8d936': {
    description: t('alerts.definitions.4c3d940f-da5f-415f-b766-6e75cdc8d936.description'),
    potential: {
      causes: t('alerts.definitions.4c3d940f-da5f-415f-b766-6e75cdc8d936.potential.causes'),
      impact: t('alerts.definitions.4c3d940f-da5f-415f-b766-6e75cdc8d936.potential.impact'),
      solutions: t('alerts.definitions.4c3d940f-da5f-415f-b766-6e75cdc8d936.potential.solutions'),
    },
    title: t('alerts.definitions.4c3d940f-da5f-415f-b766-6e75cdc8d936.title'),
  },
  '4dbda99e-2775-421c-a9a8-a6e200737ad8': {
    description: t('alerts.definitions.4dbda99e-2775-421c-a9a8-a6e200737ad8.description'),
    potential: {
      causes: t('alerts.definitions.4dbda99e-2775-421c-a9a8-a6e200737ad8.potential.causes'),
      impact: t('alerts.definitions.4dbda99e-2775-421c-a9a8-a6e200737ad8.potential.impact'),
      solutions: t('alerts.definitions.4dbda99e-2775-421c-a9a8-a6e200737ad8.potential.solutions'),
    },
    title: t('alerts.definitions.4dbda99e-2775-421c-a9a8-a6e200737ad8.title'),
  },
  '500a3b6c-3510-44c8-a033-1f5351d21674': {
    description: t('alerts.definitions.500a3b6c-3510-44c8-a033-1f5351d21674.description'),
    potential: {
      causes: t('alerts.definitions.500a3b6c-3510-44c8-a033-1f5351d21674.potential.causes'),
      impact: t('alerts.definitions.500a3b6c-3510-44c8-a033-1f5351d21674.potential.impact'),
      solutions: t('alerts.definitions.500a3b6c-3510-44c8-a033-1f5351d21674.potential.solutions'),
    },
    title: t('alerts.definitions.500a3b6c-3510-44c8-a033-1f5351d21674.title'),
  },
  '5565b490-f996-4a8f-b91b-c95c3091d300': {
    description: t('alerts.definitions.5565b490-f996-4a8f-b91b-c95c3091d300.description'),
    potential: {
      causes: t('alerts.definitions.5565b490-f996-4a8f-b91b-c95c3091d300.potential.causes'),
      impact: t('alerts.definitions.5565b490-f996-4a8f-b91b-c95c3091d300.potential.impact'),
      solutions: t('alerts.definitions.5565b490-f996-4a8f-b91b-c95c3091d300.potential.solutions'),
    },
    title: t('alerts.definitions.5565b490-f996-4a8f-b91b-c95c3091d300.title'),
  },
  '56ad1516-e17d-476d-9da9-4ae85808adec': {
    description: t('alerts.definitions.56ad1516-e17d-476d-9da9-4ae85808adec.description'),
    potential: {
      causes: t('alerts.definitions.56ad1516-e17d-476d-9da9-4ae85808adec.potential.causes'),
      impact: t('alerts.definitions.56ad1516-e17d-476d-9da9-4ae85808adec.potential.impact'),
      solutions: t('alerts.definitions.56ad1516-e17d-476d-9da9-4ae85808adec.potential.solutions'),
    },
    title: t('alerts.definitions.56ad1516-e17d-476d-9da9-4ae85808adec.title'),
  },
  '58986395-a40e-4a81-80a3-852e8231c7aa': {
    description: t('alerts.definitions.58986395-a40e-4a81-80a3-852e8231c7aa.description'),
    potential: {
      causes: t('alerts.definitions.58986395-a40e-4a81-80a3-852e8231c7aa.potential.causes'),
      impact: t('alerts.definitions.58986395-a40e-4a81-80a3-852e8231c7aa.potential.impact'),
      solutions: t('alerts.definitions.58986395-a40e-4a81-80a3-852e8231c7aa.potential.solutions'),
    },
    title: t('alerts.definitions.58986395-a40e-4a81-80a3-852e8231c7aa.title'),
  },
  '5b68ff3f-a4f2-4d6f-bd81-f03730c3eca7': {
    description: t('alerts.definitions.5b68ff3f-a4f2-4d6f-bd81-f03730c3eca7.description'),
    potential: {
      causes: t('alerts.definitions.5b68ff3f-a4f2-4d6f-bd81-f03730c3eca7.potential.causes'),
      impact: t('alerts.definitions.5b68ff3f-a4f2-4d6f-bd81-f03730c3eca7.potential.impact'),
      solutions: t('alerts.definitions.5b68ff3f-a4f2-4d6f-bd81-f03730c3eca7.potential.solutions'),
    },
    title: t('alerts.definitions.5b68ff3f-a4f2-4d6f-bd81-f03730c3eca7.title'),
  },
  '5ddfbdea-769f-4f31-9b23-005fdab28870': {
    description: t('alerts.definitions.5ddfbdea-769f-4f31-9b23-005fdab28870.description'),
    potential: {
      causes: t('alerts.definitions.5ddfbdea-769f-4f31-9b23-005fdab28870.potential.causes'),
      impact: t('alerts.definitions.5ddfbdea-769f-4f31-9b23-005fdab28870.potential.impact'),
      solutions: t('alerts.definitions.5ddfbdea-769f-4f31-9b23-005fdab28870.potential.solutions'),
    },
    title: t('alerts.definitions.5ddfbdea-769f-4f31-9b23-005fdab28870.title'),
  },
  '5df3d3d9-9b0a-4d5e-ab9f-997dde20afd3': {
    description: t('alerts.definitions.5df3d3d9-9b0a-4d5e-ab9f-997dde20afd3.description'),
    potential: {
      causes: t('alerts.definitions.5df3d3d9-9b0a-4d5e-ab9f-997dde20afd3.potential.causes'),
      impact: t('alerts.definitions.5df3d3d9-9b0a-4d5e-ab9f-997dde20afd3.potential.impact'),
      solutions: t('alerts.definitions.5df3d3d9-9b0a-4d5e-ab9f-997dde20afd3.potential.solutions'),
    },
    title: t('alerts.definitions.5df3d3d9-9b0a-4d5e-ab9f-997dde20afd3.title'),
  },
  '604345e5-7066-4b11-9d55-4738af75a994': {
    description: t('alerts.definitions.604345e5-7066-4b11-9d55-4738af75a994.description'),
    potential: {
      causes: t('alerts.definitions.604345e5-7066-4b11-9d55-4738af75a994.potential.causes'),
      impact: t('alerts.definitions.604345e5-7066-4b11-9d55-4738af75a994.potential.impact'),
      solutions: t('alerts.definitions.604345e5-7066-4b11-9d55-4738af75a994.potential.solutions'),
    },
    title: t('alerts.definitions.604345e5-7066-4b11-9d55-4738af75a994.title'),
  },
  '614e7469-c742-487b-9b5f-aa1458007828': {
    description: t('alerts.definitions.614e7469-c742-487b-9b5f-aa1458007828.description'),
    potential: {
      causes: t('alerts.definitions.614e7469-c742-487b-9b5f-aa1458007828.potential.causes'),
      impact: t('alerts.definitions.614e7469-c742-487b-9b5f-aa1458007828.potential.impact'),
      solutions: t('alerts.definitions.614e7469-c742-487b-9b5f-aa1458007828.potential.solutions'),
    },
    title: t('alerts.definitions.614e7469-c742-487b-9b5f-aa1458007828.title'),
  },
  '62b3e1d8-603e-494b-a6fb-243e598dce45': {
    description: t('alerts.definitions.62b3e1d8-603e-494b-a6fb-243e598dce45.description'),
    potential: {
      causes: t('alerts.definitions.62b3e1d8-603e-494b-a6fb-243e598dce45.potential.causes'),
      impact: t('alerts.definitions.62b3e1d8-603e-494b-a6fb-243e598dce45.potential.impact'),
      solutions: t('alerts.definitions.62b3e1d8-603e-494b-a6fb-243e598dce45.potential.solutions'),
    },
    title: t('alerts.definitions.62b3e1d8-603e-494b-a6fb-243e598dce45.title'),
  },
  '71b390da-5c70-4d59-9e53-50b8f269bba0': {
    description: t('alerts.definitions.71b390da-5c70-4d59-9e53-50b8f269bba0.description'),
    potential: {
      causes: t('alerts.definitions.71b390da-5c70-4d59-9e53-50b8f269bba0.potential.causes'),
      impact: t('alerts.definitions.71b390da-5c70-4d59-9e53-50b8f269bba0.potential.impact'),
      solutions: t('alerts.definitions.71b390da-5c70-4d59-9e53-50b8f269bba0.potential.solutions'),
    },
    title: t('alerts.definitions.71b390da-5c70-4d59-9e53-50b8f269bba0.title'),
  },
  '76cf1d81-a2d8-4dc4-b912-282578480604': {
    description: t('alerts.definitions.76cf1d81-a2d8-4dc4-b912-282578480604.description'),
    potential: {
      causes: t('alerts.definitions.76cf1d81-a2d8-4dc4-b912-282578480604.potential.causes'),
      impact: t('alerts.definitions.76cf1d81-a2d8-4dc4-b912-282578480604.potential.impact'),
      solutions: t('alerts.definitions.76cf1d81-a2d8-4dc4-b912-282578480604.potential.solutions'),
    },
    title: t('alerts.definitions.76cf1d81-a2d8-4dc4-b912-282578480604.title'),
  },
  '7aa4983d-0de9-476e-a89e-eb5b7ec4214f': {
    description: t('alerts.definitions.7aa4983d-0de9-476e-a89e-eb5b7ec4214f.description'),
    potential: {
      causes: t('alerts.definitions.7aa4983d-0de9-476e-a89e-eb5b7ec4214f.potential.causes'),
      impact: t('alerts.definitions.7aa4983d-0de9-476e-a89e-eb5b7ec4214f.potential.impact'),
      solutions: t('alerts.definitions.7aa4983d-0de9-476e-a89e-eb5b7ec4214f.potential.solutions'),
    },
    title: t('alerts.definitions.7aa4983d-0de9-476e-a89e-eb5b7ec4214f.title'),
  },
  '7dfb6fa9-fc25-43d0-ba55-52c5c1fcaaaa': {
    description: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcaaaa.description'),
    potential: {
      causes: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcaaaa.potential.causes'),
      impact: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcaaaa.potential.impact'),
      solutions: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcaaaa.potential.solutions'),
    },
    title: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcaaaa.title'),
  },
  '7dfb6fa9-fc25-43d0-ba55-52c5c1fcbbbb': {
    description: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcbbbb.description'),
    potential: {
      causes: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcbbbb.potential.causes'),
      impact: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcbbbb.potential.impact'),
      solutions: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcbbbb.potential.solutions'),
    },
    title: t('alerts.definitions.7dfb6fa9-fc25-43d0-ba55-52c5c1fcbbbb.title'),
  },
  '7e701dc2-0b96-423a-bd46-99f39c836f87': {
    description: t('alerts.definitions.7e701dc2-0b96-423a-bd46-99f39c836f87.description'),
    potential: {
      causes: t('alerts.definitions.7e701dc2-0b96-423a-bd46-99f39c836f87.potential.causes'),
      impact: t('alerts.definitions.7e701dc2-0b96-423a-bd46-99f39c836f87.potential.impact'),
      solutions: t('alerts.definitions.7e701dc2-0b96-423a-bd46-99f39c836f87.potential.solutions'),
    },
    title: t('alerts.definitions.7e701dc2-0b96-423a-bd46-99f39c836f87.title'),
  },
  '7fabf98e-d96d-4712-b1f7-7373acc0111f': {
    description: t('alerts.definitions.7fabf98e-d96d-4712-b1f7-7373acc0111f.description'),
    potential: {
      causes: t('alerts.definitions.7fabf98e-d96d-4712-b1f7-7373acc0111f.potential.causes'),
      impact: t('alerts.definitions.7fabf98e-d96d-4712-b1f7-7373acc0111f.potential.impact'),
      solutions: t('alerts.definitions.7fabf98e-d96d-4712-b1f7-7373acc0111f.potential.solutions'),
    },
    title: t('alerts.definitions.7fabf98e-d96d-4712-b1f7-7373acc0111f.title'),
  },
  '80bc87fa-438d-4455-bd5d-708d8c6bfa65': {
    description: t('alerts.definitions.80bc87fa-438d-4455-bd5d-708d8c6bfa65.description'),
    potential: {
      causes: t('alerts.definitions.80bc87fa-438d-4455-bd5d-708d8c6bfa65.potential.causes'),
      impact: t('alerts.definitions.80bc87fa-438d-4455-bd5d-708d8c6bfa65.potential.impact'),
      solutions: t('alerts.definitions.80bc87fa-438d-4455-bd5d-708d8c6bfa65.potential.solutions'),
    },
    title: t('alerts.definitions.80bc87fa-438d-4455-bd5d-708d8c6bfa65.title'),
  },
  '816f7ffc-79aa-41d7-970c-9a9bebf6eb59': {
    description: t('alerts.definitions.816f7ffc-79aa-41d7-970c-9a9bebf6eb59.description'),
    potential: {
      causes: t('alerts.definitions.816f7ffc-79aa-41d7-970c-9a9bebf6eb59.potential.causes'),
      impact: t('alerts.definitions.816f7ffc-79aa-41d7-970c-9a9bebf6eb59.potential.impact'),
      solutions: t('alerts.definitions.816f7ffc-79aa-41d7-970c-9a9bebf6eb59.potential.solutions'),
    },
    title: t('alerts.definitions.816f7ffc-79aa-41d7-970c-9a9bebf6eb59.title'),
  },
  '817dcfa6-09a6-4ac0-abf0-f412e5dc4b20': {
    description: t('alerts.definitions.817dcfa6-09a6-4ac0-abf0-f412e5dc4b20.description'),
    potential: {
      causes: t('alerts.definitions.817dcfa6-09a6-4ac0-abf0-f412e5dc4b20.potential.causes'),
      impact: t('alerts.definitions.817dcfa6-09a6-4ac0-abf0-f412e5dc4b20.potential.impact'),
      solutions: t('alerts.definitions.817dcfa6-09a6-4ac0-abf0-f412e5dc4b20.potential.solutions'),
    },
    title: t('alerts.definitions.817dcfa6-09a6-4ac0-abf0-f412e5dc4b20.title'),
  },
  '8717dd35-6d66-4c76-a31f-84c06bce0dd5': {
    description: t('alerts.definitions.8717dd35-6d66-4c76-a31f-84c06bce0dd5.description'),
    potential: {
      causes: t('alerts.definitions.8717dd35-6d66-4c76-a31f-84c06bce0dd5.potential.causes'),
      impact: t('alerts.definitions.8717dd35-6d66-4c76-a31f-84c06bce0dd5.potential.impact'),
      solutions: t('alerts.definitions.8717dd35-6d66-4c76-a31f-84c06bce0dd5.potential.solutions'),
    },
    title: t('alerts.definitions.8717dd35-6d66-4c76-a31f-84c06bce0dd5.title'),
  },
  '9030a44f-706b-406c-ba3f-83ac202824bd': {
    description: t('alerts.definitions.9030a44f-706b-406c-ba3f-83ac202824bd.description'),
    potential: {
      causes: t('alerts.definitions.9030a44f-706b-406c-ba3f-83ac202824bd.potential.causes'),
      impact: t('alerts.definitions.9030a44f-706b-406c-ba3f-83ac202824bd.potential.impact'),
      solutions: t('alerts.definitions.9030a44f-706b-406c-ba3f-83ac202824bd.potential.solutions'),
    },
    title: t('alerts.definitions.9030a44f-706b-406c-ba3f-83ac202824bd.title'),
  },
  '90c7e098-3390-46b7-b7fc-537cee615b1f': {
    description: t('alerts.definitions.90c7e098-3390-46b7-b7fc-537cee615b1f.description'),
    potential: {
      causes: t('alerts.definitions.90c7e098-3390-46b7-b7fc-537cee615b1f.potential.causes'),
      impact: t('alerts.definitions.90c7e098-3390-46b7-b7fc-537cee615b1f.potential.impact'),
      solutions: t('alerts.definitions.90c7e098-3390-46b7-b7fc-537cee615b1f.potential.solutions'),
    },
    title: t('alerts.definitions.90c7e098-3390-46b7-b7fc-537cee615b1f.title'),
  },
  '9fda33e2-156a-4cac-a5e0-d28d8d0d7d58': {
    description: t('alerts.definitions.9fda33e2-156a-4cac-a5e0-d28d8d0d7d58.description'),
    potential: {
      causes: t('alerts.definitions.9fda33e2-156a-4cac-a5e0-d28d8d0d7d58.potential.causes'),
      impact: t('alerts.definitions.9fda33e2-156a-4cac-a5e0-d28d8d0d7d58.potential.impact'),
      solutions: t('alerts.definitions.9fda33e2-156a-4cac-a5e0-d28d8d0d7d58.potential.solutions'),
    },
    title: t('alerts.definitions.9fda33e2-156a-4cac-a5e0-d28d8d0d7d58.title'),
  },
  'a0b33387-2b55-43bb-97a8-95c517ebb2fe': {
    description: t('alerts.definitions.a0b33387-2b55-43bb-97a8-95c517ebb2fe.description'),
    potential: {
      causes: t('alerts.definitions.a0b33387-2b55-43bb-97a8-95c517ebb2fe.potential.causes'),
      impact: t('alerts.definitions.a0b33387-2b55-43bb-97a8-95c517ebb2fe.potential.impact'),
      solutions: t('alerts.definitions.a0b33387-2b55-43bb-97a8-95c517ebb2fe.potential.solutions'),
    },
    title: t('alerts.definitions.a0b33387-2b55-43bb-97a8-95c517ebb2fe.title'),
  },
  'a201e3d5-7a9c-43be-be07-075c466b7d5c': {
    description: t('alerts.definitions.a201e3d5-7a9c-43be-be07-075c466b7d5c.description'),
    potential: {
      causes: t('alerts.definitions.a201e3d5-7a9c-43be-be07-075c466b7d5c.potential.causes'),
      impact: t('alerts.definitions.a201e3d5-7a9c-43be-be07-075c466b7d5c.potential.impact'),
      solutions: t('alerts.definitions.a201e3d5-7a9c-43be-be07-075c466b7d5c.potential.solutions'),
    },
    title: t('alerts.definitions.a201e3d5-7a9c-43be-be07-075c466b7d5c.title'),
  },
  'a23433cc-05e9-4382-99d8-ced483852974': {
    description: t('alerts.definitions.a23433cc-05e9-4382-99d8-ced483852974.description'),
    potential: {
      causes: t('alerts.definitions.a23433cc-05e9-4382-99d8-ced483852974.potential.causes'),
      impact: t('alerts.definitions.a23433cc-05e9-4382-99d8-ced483852974.potential.impact'),
      solutions: t('alerts.definitions.a23433cc-05e9-4382-99d8-ced483852974.potential.solutions'),
    },
    title: t('alerts.definitions.a23433cc-05e9-4382-99d8-ced483852974.title'),
  },
  'b31c10dc-7f50-4b83-b845-2233b3b8d914': {
    description: t('alerts.definitions.b31c10dc-7f50-4b83-b845-2233b3b8d914.description'),
    potential: {
      causes: t('alerts.definitions.b31c10dc-7f50-4b83-b845-2233b3b8d914.potential.causes'),
      impact: t('alerts.definitions.b31c10dc-7f50-4b83-b845-2233b3b8d914.potential.impact'),
      solutions: t('alerts.definitions.b31c10dc-7f50-4b83-b845-2233b3b8d914.potential.solutions'),
    },
    title: t('alerts.definitions.b31c10dc-7f50-4b83-b845-2233b3b8d914.title'),
  },
  'b6806338-7c07-4ffa-9097-546164020b9c': {
    description: t('alerts.definitions.b6806338-7c07-4ffa-9097-546164020b9c.description'),
    potential: {
      causes: t('alerts.definitions.b6806338-7c07-4ffa-9097-546164020b9c.potential.causes'),
      impact: t('alerts.definitions.b6806338-7c07-4ffa-9097-546164020b9c.potential.impact'),
      solutions: t('alerts.definitions.b6806338-7c07-4ffa-9097-546164020b9c.potential.solutions'),
    },
    title: t('alerts.definitions.b6806338-7c07-4ffa-9097-546164020b9c.title'),
  },
  'bf3b5ee6-3943-47ab-8c75-a26ff8fac8b9': {
    description: t('alerts.definitions.bf3b5ee6-3943-47ab-8c75-a26ff8fac8b9.description'),
    potential: {
      causes: t('alerts.definitions.bf3b5ee6-3943-47ab-8c75-a26ff8fac8b9.potential.causes'),
      impact: t('alerts.definitions.bf3b5ee6-3943-47ab-8c75-a26ff8fac8b9.potential.impact'),
      solutions: t('alerts.definitions.bf3b5ee6-3943-47ab-8c75-a26ff8fac8b9.potential.solutions'),
    },
    title: t('alerts.definitions.bf3b5ee6-3943-47ab-8c75-a26ff8fac8b9.title'),
  },
  'c1d3b67b-fb1e-41e9-9942-c1b54447364a': {
    description: t('alerts.definitions.c1d3b67b-fb1e-41e9-9942-c1b54447364a.description'),
    potential: {
      causes: t('alerts.definitions.c1d3b67b-fb1e-41e9-9942-c1b54447364a.potential.causes'),
      impact: t('alerts.definitions.c1d3b67b-fb1e-41e9-9942-c1b54447364a.potential.impact'),
      solutions: t('alerts.definitions.c1d3b67b-fb1e-41e9-9942-c1b54447364a.potential.solutions'),
    },
    title: t('alerts.definitions.c1d3b67b-fb1e-41e9-9942-c1b54447364a.title'),
  },
  'c6ae8f2c-4ff9-4be9-828c-0feed0e8648f': {
    description: t('alerts.definitions.c6ae8f2c-4ff9-4be9-828c-0feed0e8648f.description'),
    potential: {
      causes: t('alerts.definitions.c6ae8f2c-4ff9-4be9-828c-0feed0e8648f.potential.causes'),
      impact: t('alerts.definitions.c6ae8f2c-4ff9-4be9-828c-0feed0e8648f.potential.impact'),
      solutions: t('alerts.definitions.c6ae8f2c-4ff9-4be9-828c-0feed0e8648f.potential.solutions'),
    },
    title: t('alerts.definitions.c6ae8f2c-4ff9-4be9-828c-0feed0e8648f.title'),
  },
  'cfc2d74b-d258-40dc-92d7-799769cd7b08': {
    description: t('alerts.definitions.cfc2d74b-d258-40dc-92d7-799769cd7b08.description'),
    potential: {
      causes: t('alerts.definitions.cfc2d74b-d258-40dc-92d7-799769cd7b08.potential.causes'),
      impact: t('alerts.definitions.cfc2d74b-d258-40dc-92d7-799769cd7b08.potential.impact'),
      solutions: t('alerts.definitions.cfc2d74b-d258-40dc-92d7-799769cd7b08.potential.solutions'),
    },
    title: t('alerts.definitions.cfc2d74b-d258-40dc-92d7-799769cd7b08.title'),
  },
  'd1d2b3a3-a4c8-4e62-85ac-6dcd1ca1e6d0': {
    description: t('alerts.definitions.d1d2b3a3-a4c8-4e62-85ac-6dcd1ca1e6d0.description'),
    potential: {
      causes: t('alerts.definitions.d1d2b3a3-a4c8-4e62-85ac-6dcd1ca1e6d0.potential.causes'),
      impact: t('alerts.definitions.d1d2b3a3-a4c8-4e62-85ac-6dcd1ca1e6d0.potential.impact'),
      solutions: t('alerts.definitions.d1d2b3a3-a4c8-4e62-85ac-6dcd1ca1e6d0.potential.solutions'),
    },
    title: t('alerts.definitions.d1d2b3a3-a4c8-4e62-85ac-6dcd1ca1e6d0.title'),
  },
  'd7b37f1a-4861-4b8f-863b-92dd80a1c91b': {
    description: t('alerts.definitions.d7b37f1a-4861-4b8f-863b-92dd80a1c91b.description'),
    potential: {
      causes: t('alerts.definitions.d7b37f1a-4861-4b8f-863b-92dd80a1c91b.potential.causes'),
      impact: t('alerts.definitions.d7b37f1a-4861-4b8f-863b-92dd80a1c91b.potential.impact'),
      solutions: t('alerts.definitions.d7b37f1a-4861-4b8f-863b-92dd80a1c91b.potential.solutions'),
    },
    title: t('alerts.definitions.d7b37f1a-4861-4b8f-863b-92dd80a1c91b.title'),
  },
  'd8c9f02c-dc48-445a-85f3-c46036e97a56': {
    description: t('alerts.definitions.d8c9f02c-dc48-445a-85f3-c46036e97a56.description'),
    potential: {
      causes: t('alerts.definitions.d8c9f02c-dc48-445a-85f3-c46036e97a56.potential.causes'),
      impact: t('alerts.definitions.d8c9f02c-dc48-445a-85f3-c46036e97a56.potential.impact'),
      solutions: t('alerts.definitions.d8c9f02c-dc48-445a-85f3-c46036e97a56.potential.solutions'),
    },
    title: t('alerts.definitions.d8c9f02c-dc48-445a-85f3-c46036e97a56.title'),
  },
  'debf5b5a-6867-4d22-bcd7-e114028e0c7f': {
    description: t('alerts.definitions.debf5b5a-6867-4d22-bcd7-e114028e0c7f.description'),
    potential: {
      causes: t('alerts.definitions.debf5b5a-6867-4d22-bcd7-e114028e0c7f.potential.causes'),
      impact: t('alerts.definitions.debf5b5a-6867-4d22-bcd7-e114028e0c7f.potential.impact'),
      solutions: t('alerts.definitions.debf5b5a-6867-4d22-bcd7-e114028e0c7f.potential.solutions'),
    },
    title: t('alerts.definitions.debf5b5a-6867-4d22-bcd7-e114028e0c7f.title'),
  },
  'e11a16f3-7a17-497f-9ce5-d3dfc79c048f': {
    description: t('alerts.definitions.e11a16f3-7a17-497f-9ce5-d3dfc79c048f.description'),
    potential: {
      causes: t('alerts.definitions.e11a16f3-7a17-497f-9ce5-d3dfc79c048f.potential.causes'),
      impact: t('alerts.definitions.e11a16f3-7a17-497f-9ce5-d3dfc79c048f.potential.impact'),
      solutions: t('alerts.definitions.e11a16f3-7a17-497f-9ce5-d3dfc79c048f.potential.solutions'),
    },
    title: t('alerts.definitions.e11a16f3-7a17-497f-9ce5-d3dfc79c048f.title'),
  },
  'e156b68f-a2b9-483b-b9e2-79a26eddcd10': {
    description: t('alerts.definitions.e156b68f-a2b9-483b-b9e2-79a26eddcd10.description'),
    potential: {
      causes: t('alerts.definitions.e156b68f-a2b9-483b-b9e2-79a26eddcd10.potential.causes'),
      impact: t('alerts.definitions.e156b68f-a2b9-483b-b9e2-79a26eddcd10.potential.impact'),
      solutions: t('alerts.definitions.e156b68f-a2b9-483b-b9e2-79a26eddcd10.potential.solutions'),
    },
    title: t('alerts.definitions.e156b68f-a2b9-483b-b9e2-79a26eddcd10.title'),
  },
  'e434e4e5-7a3e-43be-a14b-8ad9e9b77ff5': {
    description: t('alerts.definitions.e434e4e5-7a3e-43be-a14b-8ad9e9b77ff5.description'),
    potential: {
      causes: t('alerts.definitions.e434e4e5-7a3e-43be-a14b-8ad9e9b77ff5.potential.causes'),
      impact: t('alerts.definitions.e434e4e5-7a3e-43be-a14b-8ad9e9b77ff5.potential.impact'),
      solutions: t('alerts.definitions.e434e4e5-7a3e-43be-a14b-8ad9e9b77ff5.potential.solutions'),
    },
    title: t('alerts.definitions.e434e4e5-7a3e-43be-a14b-8ad9e9b77ff5.title'),
  },
  'fb0722f4-7c01-4972-a12e-e0beebf69c92': {
    description: t('alerts.definitions.fb0722f4-7c01-4972-a12e-e0beebf69c92.description'),
    potential: {
      causes: t('alerts.definitions.fb0722f4-7c01-4972-a12e-e0beebf69c92.potential.causes'),
      impact: t('alerts.definitions.fb0722f4-7c01-4972-a12e-e0beebf69c92.potential.impact'),
      solutions: t('alerts.definitions.fb0722f4-7c01-4972-a12e-e0beebf69c92.potential.solutions'),
    },
    title: t('alerts.definitions.fb0722f4-7c01-4972-a12e-e0beebf69c92.title'),
  },
}
